'use strict';

import * as moment from 'moment';
import { dataMember, required, typedArray } from 'santee-dcts';
import { deserializers } from '../../core';

export class Accession {

    @dataMember()
    @required()
    public accessionId: number;

    @dataMember()
    @required()
    public accessionNumber: string;

    @dataMember()
    @required({ nullable: true })
    public visit: string;

    @dataMember()
    @required({ nullable: true })
    public projectNumber: string;

    @dataMember({ customDeserializer: deserializers.deserializeDate })
    @required({ nullable: true })
    public collectionDate: moment.Moment;

    public toString() {
        return [
            this.accessionNumber,
            this.visit,
            this.collectionDate ? this.collectionDate.format('L LT') : null
        ].filter(x => !!x).join(' - ');
    }
}

export class AccessionReadModel {
    @dataMember()
    @required()
    @typedArray(Accession)
    public accessions: Accession[];
}